export const mockData = {
  hero: {
    title: "Transform Your Vision Into Reality",
    subtitle: "Comprehensive digital solutions for schools, universities, HR teams, startups, and content creators",
    cta: "Get Started Today"
  },
  
  services: [
    {
      id: "website",
      name: "Website Development",
      description: "Custom, responsive websites that engage your audience and drive results. Built with modern technologies and optimized for performance.",
      icon: "Globe",
      fullDescription: "Transform your online presence with custom-built websites that combine stunning design with powerful functionality. Our expert team creates responsive, fast-loading sites optimized for conversions and user experience.",
      features: [
        "Custom responsive design",
        "CMS integration",
        "SEO optimization",
        "Performance tuning",
        "Analytics integration",
        "Ongoing maintenance"
      ],
      technologies: ["React", "Next.js", "WordPress", "Shopify"],
      startingPrice: "$2,500"
    },
    {
      id: "app",
      name: "App Development",
      description: "Native and cross-platform mobile applications that deliver seamless user experiences across all devices.",
      icon: "Smartphone",
      fullDescription: "Build powerful mobile applications that users love. From iOS to Android, we create intuitive apps that solve real problems and drive engagement.",
      features: [
        "iOS & Android development",
        "Cross-platform solutions",
        "API integration",
        "Push notifications",
        "In-app purchases",
        "App store optimization"
      ],
      technologies: ["React Native", "Flutter", "Swift", "Kotlin"],
      startingPrice: "$15,000"
    },
    {
      id: "design",
      name: "Design Services",
      description: "Beautiful, user-centric designs that capture your brand identity and create lasting impressions.",
      icon: "Palette",
      fullDescription: "Create a memorable brand with designs that resonate with your audience. From logos to complete brand systems, we craft visual identities that stand out.",
      features: [
        "Brand identity design",
        "UI/UX design",
        "Logo & graphics",
        "Marketing materials",
        "Design systems",
        "Style guides"
      ],
      technologies: ["Figma", "Adobe Creative Suite", "Sketch"],
      startingPrice: "$1,500"
    },
    {
      id: "marketing",
      name: "Digital Marketing",
      description: "Strategic marketing campaigns that amplify your reach and convert prospects into loyal customers.",
      icon: "TrendingUp",
      fullDescription: "Grow your business with data-driven marketing strategies. We help you reach the right audience, at the right time, with the right message.",
      features: [
        "SEO & content marketing",
        "Social media management",
        "PPC advertising",
        "Email campaigns",
        "Analytics & reporting",
        "Conversion optimization"
      ],
      technologies: ["Google Ads", "Facebook Ads", "HubSpot", "Mailchimp"],
      startingPrice: "$1,000/mo"
    },
    {
      id: "finance",
      name: "Finance Solutions",
      description: "Financial management tools and consulting services to optimize your business operations and growth.",
      icon: "DollarSign",
      fullDescription: "Streamline your financial operations with smart tools and expert consulting. Make informed decisions with real-time insights and forecasting.",
      features: [
        "Financial planning",
        "Accounting software setup",
        "Budget forecasting",
        "Financial reporting",
        "Tax optimization",
        "CFO consulting"
      ],
      technologies: ["QuickBooks", "Xero", "FreshBooks", "Custom Solutions"],
      startingPrice: "$500/mo"
    }
  ],
  
  clientTypes: [
    {
      id: "schools",
      name: "Schools",
      description: "Streamline administration, enhance student engagement, and modernize your educational platform with our tailored solutions.",
      benefits: ["Student Management Systems", "Parent Communication Portals", "Online Learning Platforms"]
    },
    {
      id: "universities",
      name: "Universities",
      description: "Scale your institution with enterprise-grade systems for enrollment, learning management, and campus operations.",
      benefits: ["Course Management", "Research Portals", "Alumni Networks"]
    },
    {
      id: "hr",
      name: "HR Departments",
      description: "Automate recruitment, onboarding, and employee management with intelligent HR tech solutions.",
      benefits: ["Applicant Tracking", "Performance Management", "Employee Self-Service"]
    },
    {
      id: "startups",
      name: "Startups",
      description: "Launch faster with MVP development, branding, and growth marketing designed for early-stage companies.",
      benefits: ["Rapid Prototyping", "Brand Identity", "Growth Hacking"]
    },
    {
      id: "creators",
      name: "Content Creators",
      description: "Build your personal brand with stunning portfolios, monetization tools, and audience engagement platforms.",
      benefits: ["Portfolio Websites", "E-commerce Integration", "Analytics Dashboard"]
    }
  ],
  
  whyChooseUs: [
    {
      title: "Expert Team",
      description: "Seasoned professionals with years of experience across multiple industries and technologies."
    },
    {
      title: "Custom Solutions",
      description: "Tailored approaches that fit your unique needs, not one-size-fits-all templates."
    },
    {
      title: "On-Time Delivery",
      description: "We respect your timeline and deliver projects when we promise, every time."
    },
    {
      title: "Ongoing Support",
      description: "Your success is our success. We provide continued support long after launch."
    }
  ],
  
  stats: [
    { number: "500+", label: "Projects Completed" },
    { number: "250+", label: "Happy Clients" },
    { number: "15+", label: "Countries Served" },
    { number: "99%", label: "Client Satisfaction" }
  ],
  
  testimonials: [
    {
      name: "Sarah Mitchell",
      role: "Principal, Westwood Academy",
      quote: "Skyretieducore transformed our school's digital presence. The parent portal they built has improved communication tremendously.",
      image: "SM"
    },
    {
      name: "David Chen",
      role: "Founder, TechStart Inc",
      quote: "From concept to launch in just 8 weeks. Their startup package gave us exactly what we needed to get to market fast.",
      image: "DC"
    },
    {
      name: "Maria Rodriguez",
      role: "HR Director, GlobalCorp",
      quote: "The employee management system streamlined our entire HR workflow. It's been a game-changer for our department.",
      image: "MR"
    }
  ],

  portfolio: [
    {
      id: 1,
      title: "EduConnect Platform",
      client: "Riverside University",
      category: "universities",
      service: "website",
      image: "portfolio1",
      description: "Complete learning management system connecting 15,000+ students with interactive coursework and faculty.",
      results: ["45% increase in student engagement", "92% user satisfaction", "Reduced admin time by 60%"],
      technologies: ["React", "Node.js", "MongoDB"],
      year: 2024
    },
    {
      id: 2,
      title: "TalentTrack HR Suite",
      client: "GlobalTech Solutions",
      category: "hr",
      service: "app",
      image: "portfolio2",
      description: "Mobile-first HR management app handling recruitment, onboarding, and performance tracking for 500+ employees.",
      results: ["70% faster hiring process", "Eliminated 80% of paperwork", "5-star rating on app stores"],
      technologies: ["React Native", "Firebase", "AWS"],
      year: 2024
    },
    {
      id: 3,
      title: "CreatorHub",
      client: "Independent Content Creators",
      category: "creators",
      service: "website",
      image: "portfolio3",
      description: "All-in-one platform for content creators to showcase work, sell digital products, and engage their audience.",
      results: ["300% increase in revenue", "10,000+ monthly visitors", "Built-in payment processing"],
      technologies: ["Next.js", "Stripe", "PostgreSQL"],
      year: 2023
    },
    {
      id: 4,
      title: "SchoolSync",
      client: "Maple Grove School District",
      category: "schools",
      service: "app",
      image: "portfolio4",
      description: "Parent communication app with real-time updates, grade tracking, and event notifications.",
      results: ["95% parent adoption rate", "50% reduction in missed communications", "Featured in EdTech magazine"],
      technologies: ["Flutter", "Python", "Docker"],
      year: 2023
    },
    {
      id: 5,
      title: "StartupOS Brand Identity",
      client: "Multiple Startups",
      category: "startups",
      service: "design",
      image: "portfolio5",
      description: "Complete branding packages for early-stage startups including logos, style guides, and marketing materials.",
      results: ["25+ successful launches", "Average $100K funding increase", "Award-winning designs"],
      technologies: ["Figma", "Adobe Suite"],
      year: 2024
    },
    {
      id: 6,
      title: "FinanceFlow Dashboard",
      client: "GrowthCo Startup",
      category: "startups",
      service: "finance",
      image: "portfolio6",
      description: "Real-time financial dashboard with forecasting, budgeting, and investor reporting features.",
      results: ["Secured $2M Series A", "Real-time cash flow visibility", "Automated investor reporting"],
      technologies: ["React", "Python", "QuickBooks API"],
      year: 2023
    }
  ],

  pricingPlans: [
    {
      name: "Starter",
      price: "$2,500",
      period: "one-time",
      description: "Perfect for small projects and getting started",
      features: [
        "Basic website or landing page",
        "Up to 5 pages",
        "Responsive design",
        "Basic SEO setup",
        "1 month support",
        "Standard delivery (4 weeks)"
      ],
      highlighted: false,
      cta: "Get Started"
    },
    {
      name: "Professional",
      price: "$8,500",
      period: "one-time",
      description: "Ideal for growing businesses and comprehensive solutions",
      features: [
        "Custom website or app",
        "Up to 15 pages/screens",
        "Advanced features & integrations",
        "SEO optimization",
        "3 months support",
        "Content management system",
        "Analytics setup",
        "Priority delivery (6 weeks)"
      ],
      highlighted: true,
      cta: "Most Popular"
    },
    {
      name: "Enterprise",
      price: "Custom",
      period: "quote",
      description: "For large organizations needing complete solutions",
      features: [
        "Unlimited pages/screens",
        "Custom features & integrations",
        "Advanced security",
        "Dedicated project manager",
        "12 months support",
        "Training & documentation",
        "SLA guarantee",
        "White-glove service"
      ],
      highlighted: false,
      cta: "Contact Sales"
    }
  ],

  faqs: [
    {
      question: "How long does a typical project take?",
      answer: "Project timelines vary based on scope. A basic website typically takes 3-4 weeks, while custom applications can take 8-16 weeks. We provide detailed timelines during the consultation phase.",
      category: "general"
    },
    {
      question: "Do you offer ongoing maintenance and support?",
      answer: "Yes! All projects include a support period, and we offer monthly maintenance packages starting at $200/month. This includes updates, security patches, and technical support.",
      category: "general"
    },
    {
      question: "What technologies do you work with?",
      answer: "We specialize in modern tech stacks including React, Next.js, Node.js, Python, React Native, and Flutter. We choose the best technology based on your specific needs and goals.",
      category: "technical"
    },
    {
      question: "Can you work with our existing systems?",
      answer: "Absolutely! We have extensive experience integrating with existing systems, APIs, and databases. We can work with your current tech stack or help migrate to new solutions.",
      category: "technical"
    },
    {
      question: "What is your payment structure?",
      answer: "We typically work with a 50% deposit to start, 25% at mid-project milestone, and 25% upon completion. For monthly services, we bill at the beginning of each month.",
      category: "pricing"
    },
    {
      question: "Do you provide training for our team?",
      answer: "Yes! All projects include comprehensive documentation and training sessions to ensure your team can effectively manage and maintain the solution we deliver.",
      category: "services"
    },
    {
      question: "What if I need changes after the project is complete?",
      answer: "Minor adjustments during the support period are included. For larger changes or new features, we can provide a quote or set up a monthly retainer for ongoing development.",
      category: "services"
    },
    {
      question: "Do you sign NDAs?",
      answer: "Yes, we're happy to sign non-disclosure agreements to protect your confidential information and intellectual property.",
      category: "legal"
    }
  ],

  clients: [
    { name: "Riverside University", logo: "RU" },
    { name: "GlobalTech Solutions", logo: "GTS" },
    { name: "Maple Grove Schools", logo: "MGS" },
    { name: "TechStart Inc", logo: "TSI" },
    { name: "CreatorHub", logo: "CH" },
    { name: "Westwood Academy", logo: "WA" },
    { name: "InnovateCo", logo: "IC" },
    { name: "FutureLearn", logo: "FL" }
  ],

  awards: [
    { title: "Best EdTech Solution 2024", organization: "Tech Innovation Awards" },
    { title: "Top 50 Development Agencies", organization: "Business Weekly" },
    { title: "Excellence in Design", organization: "Creative Awards 2023" }
  ],

  team: [
    {
      name: "Alex Johnson",
      role: "Founder & CEO",
      bio: "15+ years building digital solutions for education and enterprise. Former CTO at EdTech startup acquired in 2019.",
      initials: "AJ",
      specialties: ["Strategy", "Product Development"]
    },
    {
      name: "Priya Patel",
      role: "Head of Design",
      bio: "Award-winning designer passionate about creating intuitive user experiences. Previously at top design agencies in SF and NYC.",
      initials: "PP",
      specialties: ["UI/UX", "Brand Identity"]
    },
    {
      name: "Marcus Chen",
      role: "Lead Developer",
      bio: "Full-stack developer specializing in scalable web and mobile applications. Open source contributor and tech speaker.",
      initials: "MC",
      specialties: ["React", "Node.js", "Cloud Architecture"]
    },
    {
      name: "Sarah Williams",
      role: "Marketing Director",
      bio: "Growth marketing expert with proven track record of 10x-ing client acquisition. Former Head of Growth at SaaS unicorn.",
      initials: "SW",
      specialties: ["SEO", "Content Marketing", "Analytics"]
    }
  ],

  blogPosts: [
    {
      id: 1,
      title: "5 Must-Have Features for Modern Educational Platforms",
      excerpt: "Discover the essential features that make educational platforms effective and engaging for students and teachers alike.",
      category: "Education",
      date: "2024-12-15",
      readTime: "5 min read",
      author: "Alex Johnson",
      slug: "must-have-features-educational-platforms",
      content: "Full blog post content would go here..."
    },
    {
      id: 2,
      title: "The Ultimate Guide to HR Tech Stack Selection",
      excerpt: "Choosing the right HR technology can transform your people operations. Here's how to make the right choice.",
      category: "HR Tech",
      date: "2024-12-10",
      readTime: "8 min read",
      author: "Sarah Williams",
      slug: "hr-tech-stack-guide",
      content: "Full blog post content would go here..."
    },
    {
      id: 3,
      title: "Building a Brand That Stands Out: A Startup Guide",
      excerpt: "Your brand is more than a logo. Learn how to create a memorable brand identity that resonates with your target audience.",
      category: "Branding",
      date: "2024-12-05",
      readTime: "6 min read",
      author: "Priya Patel",
      slug: "building-brand-startup-guide",
      content: "Full blog post content would go here..."
    },
    {
      id: 4,
      title: "Mobile App Development: Native vs Cross-Platform in 2024",
      excerpt: "Should you build native or go cross-platform? We break down the pros, cons, and costs of each approach.",
      category: "Development",
      date: "2024-11-28",
      readTime: "7 min read",
      author: "Marcus Chen",
      slug: "native-vs-cross-platform-2024",
      content: "Full blog post content would go here..."
    }
  ],

  careers: [
    {
      id: 1,
      title: "Senior Full-Stack Developer",
      department: "Engineering",
      location: "Remote",
      type: "Full-time",
      description: "Join our engineering team to build cutting-edge web applications for education and enterprise clients.",
      requirements: ["5+ years experience", "React & Node.js expertise", "Strong problem-solving skills"]
    },
    {
      id: 2,
      title: "UI/UX Designer",
      department: "Design",
      location: "Remote / Hybrid",
      type: "Full-time",
      description: "Create beautiful, intuitive designs that delight users and drive business results.",
      requirements: ["3+ years experience", "Figma proficiency", "Portfolio required"]
    },
    {
      id: 3,
      title: "Digital Marketing Specialist",
      department: "Marketing",
      location: "Remote",
      type: "Full-time",
      description: "Drive growth for our clients and our own agency through strategic digital marketing campaigns.",
      requirements: ["2+ years experience", "SEO & PPC knowledge", "Data-driven mindset"]
    }
  ]
};
